import React, { Component } from 'react';

import './ReportFilter.scss';

export default class ReportFilter extends Component {
  render() {
    const { minWidth, height, isVertical, altClassName } = this.props;
    const style = { 
      'minWidth': minWidth ? minWidth : null,
      height: height ? height : null,
    };

    let className = altClassName ? altClassName : 'ReportFilter';
    className += isVertical ? ' ' + className + '--vertical' : '';

    return (
      <div className={className} style={style}>
        {
          !this.props.hideTabIndicator && 
          <div className={'tab-indicator' + (isVertical ? ' tab-indicator--vertical' : '')}></div>
        }
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ReportFilter/index.js